exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.total-count[data-v-ff568efc] {\n  margin-bottom: 12px;\n}\n.filters[data-v-ff568efc] {\n  margin-bottom: 12px;\n}\n.c-file[data-v-ff568efc] {\n  margin-top: 12px;\n}\n.submit-form-container[data-v-ff568efc] {\n  margin-top: 12px;\n}\n.submit-button[data-v-ff568efc] {\n  margin-top: 12px;\n  color: #fff;\n  background: #25d366;\n  width: 180px;\n  border: none;\n}\n", ""]);

// exports
